import { render } from "./Member.vue?vue&type=template&id=139a75ca"
import script from "./Member.vue?vue&type=script&lang=ts"
export * from "./Member.vue?vue&type=script&lang=ts"
script.render = render

export default script